<template>
  <div class="ms-excel-page container py-4">
    <!-- Page Heading -->
    <h2 class="mb-4">MS Excel</h2>

    <!-- Description / Introduction -->
    <p>
      MS Excel is a spreadsheet application used for data organization, calculation, analysis, and visualization.
      It provides powerful tools for formulas, charts, pivot tables, and data management.
    </p>

    <!-- Example Features List -->
    <h5 class="mt-4">Key Features of MS Excel:</h5>
    <ul>
      <li>Organizing data in rows and columns</li>
      <li>Performing calculations using formulas and functions</li>
      <li>Creating charts and graphs for visualization</li>
      <li>Using PivotTables and PivotCharts for data analysis</li>
      <li>Conditional formatting and data validation</li>
    </ul>

    <!-- Example Image / Screenshot -->
    <div class="mt-4 text-center">
      <img
        src="@/assets/Tutorials/MSOffice/ms-excel.png"
        alt="MS Excel Example"
        class="img-fluid rounded shadow-sm"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "MsExcel",
};
</script>

<style scoped>
h2 {
  color: #047857; /* Green heading for Excel */
  font-weight: 700;
}

ul {
  list-style-type: disc;
  margin-left: 20px;
}

p {
  font-size: 1rem;
  line-height: 1.6;
  color: #374151;
}

img {
  max-width: 100%;
  height: auto;
}
</style>
